import { CSSProperties } from 'react';

type StyleProps = {
    style?: CSSProperties;
};

const GoogleIcon = ({ style }: StyleProps) => (
    <svg
        className="rwlGoogleIcon"
        width="16"
        height="16"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
    >
        <path
            d="M18 9.21583C18 8.608 17.94 7.98056 17.84 7.39233H9.17755V10.8629H14.1389C13.9389 11.9805 13.2787 12.9609 12.2984 13.5883L15.2592 15.8432C16.9997 14.2549 18 11.9413 18 9.21583Z"
            fill="#4280EF"
        />
        <path
            d="M9.17754 17.9999C11.6582 17.9999 13.7388 17.196 15.2592 15.8235L12.2984 13.5882C11.4782 14.1372 10.4179 14.4509 9.17754 14.4509C6.77688 14.4509 4.75632 12.8627 4.01611 10.7451L0.975266 13.0392C2.5357 16.0783 5.69658 17.9999 9.17754 17.9999Z"
            fill="#34A353"
        />
        <path
            d="M4.01611 10.7255C3.63601 9.60791 3.63601 8.39224 4.01611 7.27462L0.975271 4.96094C-0.32509 7.50991 -0.32509 10.5099 0.975271 13.0392L4.01611 10.7255Z"
            fill="#F6B704"
        />
        <path
            d="M9.17754 3.5689C10.4779 3.54929 11.7583 4.03948 12.6985 4.92182L15.3193 2.33363C13.6588 0.804248 11.4582 -0.0192653 9.17754 0.000342207C5.69658 0.000342207 2.5357 1.92187 0.975266 4.96103L4.01611 7.27471C4.75632 5.1375 6.77688 3.5689 9.17754 3.5689Z"
            fill="#E54335"
        />
    </svg>
);

const FacebookIcon = ({ style }: StyleProps) => (
    <svg
        className="rwlFacebookIcon"
        width="16"
        height="16"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
    >
        <g clipPath="url(#clip0_542_288)">
            <path
                d="M24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 17.9895 4.8882 22.954 10.625 23.8542V15.4688H7.57812V12H10.625V9.35625C10.625 6.34875 12.4166 4.6875 15.1576 4.6875C16.4701 4.6875 17.8438 4.92188 17.8438 4.92188V7.875H16.3306C14.84 7.875 14.375 8.80008 14.375 9.75V12H17.7031L17.1711 15.4688H14.375V23.8542C20.1118 22.954 24.5 17.9895 24.5 12Z"
                fill="#0866FF"
            />
        </g>
        <defs>
            <clipPath id="clip0_542_288">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

const InternalIcon = ({ style }: StyleProps) => (
    <svg
        className="rwlInternalIcon"
        width="341"
        height="194"
        viewBox="0 0 341 194"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '24px', height: 'auto', ...style }}
    >
        <g clipPath="url(#clip0_37_113)">
            <path
                d="M0.708764 7.86068L102.687 192.02C104.219 194.677 108.057 194.656 109.56 191.982L140.982 128.775C141.649 127.587 141.659 126.138 141.007 124.941L105.491 59.72C104.055 57.0823 105.962 53.8673 108.964 53.8673H137.76C141.371 53.8673 144.728 55.7295 146.641 58.7949L161.855 83.1646C163.443 85.7095 167.173 85.6286 168.65 83.0172L212.265 5.90854C213.758 3.26976 211.853 0 208.824 0H5.24422C1.21375 0 -1.30568 4.36659 0.708764 7.86068Z"
                fill="#115CED"
            />
            <path
                d="M264.528 0C263.118 0 261.815 0.751173 261.107 1.97165L189.832 124.909C189.129 126.121 189.119 127.615 189.805 128.836L225.237 191.904C225.937 193.151 227.255 193.922 228.684 193.922H229.379C231.25 193.922 232.979 192.923 233.915 191.301L339.673 7.86067C341.687 4.36658 339.168 0 335.138 0H264.528Z"
                fill="#115CED"
            />
            <path
                d="M174.314 193.922C177.436 193.922 179.327 190.472 177.65 187.837L168.911 174.105C167.309 171.586 163.604 171.683 162.134 174.281L154.367 188.014C152.874 190.652 154.779 193.922 157.808 193.922H174.314Z"
                fill="#115CED"
            />
        </g>
        <defs>
            <clipPath id="clip0_37_113">
                <rect width="341" height="194" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const InstagramIcon = ({ style }: { style?: React.CSSProperties }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="20"
        height="20"
        viewBox="0 0 132 132"
        style={style}
        preserveAspectRatio="xMidYMid meet"
    >
        <defs>
            <linearGradient id="b">
                <stop offset="0" stopColor="#3771c8" />
                <stop offset=".128" stopColor="#3771c8" />
                <stop offset="1" stopColor="#60f" stopOpacity="0" />
            </linearGradient>
            <linearGradient id="a">
                <stop offset="0" stopColor="#fd5" />
                <stop offset=".1" stopColor="#fd5" />
                <stop offset=".5" stopColor="#ff543e" />
                <stop offset="1" stopColor="#c837ab" />
            </linearGradient>
            <radialGradient
                id="c"
                cx="158.429"
                cy="578.088"
                r="65"
                xlinkHref="#a"
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(0 -1.98198 1.8439 0 -1031.402 454.004)"
                fx="158.429"
                fy="578.088"
            />
            <radialGradient
                id="d"
                cx="147.694"
                cy="473.455"
                r="65"
                xlinkHref="#b"
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(.17394 .86872 -3.5818 .71718 1648.348 -458.493)"
                fx="147.694"
                fy="473.455"
            />
        </defs>

        <path
            fill="url(#c)"
            d="M65.03 0C37.888 0 29.95.028 28.407.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468C4 13.126 1.5 18.394.595 24.656c-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28 7.79-2.01 14.24-7.29 17.75-14.53 1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624C116.9 4 111.64 1.5 105.372.596 102.335.157 101.73.027 86.19 0H65.03z"
            transform="translate(1.004 1)"
        />
        <path
            fill="url(#d)"
            d="M65.03 0C37.888 0 29.95.028 28.407.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468C4 13.126 1.5 18.394.595 24.656c-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28 7.79-2.01 14.24-7.29 17.75-14.53 1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624C116.9 4 111.64 1.5 105.372.596 102.335.157 101.73.027 86.19 0H65.03z"
            transform="translate(1.004 1)"
        />
        <path
            fill="#fff"
            d="M66.004 18c-13.036 0-14.672.057-19.792.29-5.11.234-8.598 1.043-11.65 2.23-3.157 1.226-5.835 2.866-8.503 5.535-2.67 2.668-4.31 5.346-5.54 8.502-1.19 3.053-2 6.542-2.23 11.65C18.06 51.327 18 52.964 18 66s.058 14.667.29 19.787c.235 5.11 1.044 8.598 2.23 11.65 1.227 3.157 2.867 5.835 5.536 8.503 2.667 2.67 5.345 4.314 8.5 5.54 3.054 1.187 6.543 1.996 11.652 2.23 5.12.233 6.755.29 19.79.29 13.037 0 14.668-.057 19.788-.29 5.11-.234 8.602-1.043 11.656-2.23 3.156-1.226 5.83-2.87 8.497-5.54 2.67-2.668 4.31-5.346 5.54-8.502 1.18-3.053 1.99-6.542 2.23-11.65.23-5.12.29-6.752.29-19.788 0-13.036-.06-14.672-.29-19.792-.24-5.11-1.05-8.598-2.23-11.65-1.23-3.157-2.87-5.835-5.54-8.503-2.67-2.67-5.34-4.31-8.5-5.535-3.06-1.187-6.55-1.996-11.66-2.23-5.12-.233-6.75-.29-19.79-.29zm-4.306 8.65c1.278-.002 2.704 0 4.306 0 12.816 0 14.335.046 19.396.276 4.68.214 7.22.996 8.912 1.653 2.24.87 3.837 1.91 5.516 3.59 1.68 1.68 2.72 3.28 3.592 5.52.657 1.69 1.44 4.23 1.653 8.91.23 5.06.28 6.58.28 19.39s-.05 14.33-.28 19.39c-.214 4.68-.996 7.22-1.653 8.91-.87 2.24-1.912 3.835-3.592 5.514-1.68 1.68-3.275 2.72-5.516 3.59-1.69.66-4.232 1.44-8.912 1.654-5.06.23-6.58.28-19.396.28-12.817 0-14.336-.05-19.396-.28-4.68-.216-7.22-.998-8.913-1.655-2.24-.87-3.84-1.91-5.52-3.59-1.68-1.68-2.72-3.276-3.592-5.517-.657-1.69-1.44-4.23-1.653-8.91-.23-5.06-.276-6.58-.276-19.398s.046-14.33.276-19.39c.214-4.68.996-7.22 1.653-8.912.87-2.24 1.912-3.84 3.592-5.52 1.68-1.68 3.28-2.72 5.52-3.592 1.692-.66 4.233-1.44 8.913-1.655 4.428-.2 6.144-.26 15.09-.27zm29.928 7.97c-3.18 0-5.76 2.577-5.76 5.758 0 3.18 2.58 5.76 5.76 5.76 3.18 0 5.76-2.58 5.76-5.76 0-3.18-2.58-5.76-5.76-5.76zm-25.622 6.73c-13.613 0-24.65 11.037-24.65 24.65 0 13.613 11.037 24.645 24.65 24.645C79.617 90.645 90.65 79.613 90.65 66S79.616 41.35 66.003 41.35zm0 8.65c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16 0-8.837 7.163-16 16-16z"
        />
    </svg>
);

export const SourceIcon = ({
    source,
    style,
}: StyleProps & {
    source?: string;
}): JSX.Element | null => {
    switch (source) {
        case 'Facebook':
            return <FacebookIcon style={style} />;
        case 'GMB':
            return <GoogleIcon style={style} />;
        case 'Instagram':
            return <InstagramIcon style={style} />;
        case 'Internal':
            return <InternalIcon style={style} />;
    }

    return null;
};
